import {
  AccountActionTileListFragment,
  AnalyticsEventFragment,
  BannerPromotionTileFragment,
  CheckListItemTileFragment,
  ColumnTaxTileFragment,
  CreditScoreTileFragment,
  DiscoverMoreProductRowTileFragment,
  IllustrationStyleDictionaryFragment,
  InternalAccountTileFragment,
  LinkedAccountsTileFragment,
  NextBestActionTileFragment,
  PartnerOfferTileFragment,
  PayOverTimeItemsTileFragment,
  ProductOfferSingleCardTileFragment,
  ProductOfferTileFragment,
  PromotionTileFragment,
  QuickActionListFragment,
  RouteNavigationActionFragment,
  SDVerticalStackContainerTileFragment,
  SelfFundedOfferTileFragment,
  SystemBannerFragment,
  TagFragment,
  TopPerksTileFragment,
  VaroToAnyoneTileFragment,
  VXLCardGroupDiscoverMoreTileFragment,
  VXLSideBySideTileFragment,
  VXLTrackerCardTileFragment,
} from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

// NOTE: this query should be kept in perfect sync with FetchHomeTilesV2 (minus this group fragment)
export const VXLCardGroupTileFragment = gql`
  fragment VXLCardGroupTileFragment on VXLCardGroupTile {
    __typename
    id
    status
    tileType
    title
    subtitle
    progress {
      __typename
      numerator
      denominator
    }
    displayAnalytics {
      ...AnalyticsEventFragment
    }
    tiles {
      ...QuickActionListFragment
      ...InternalAccountTileFragment
      ...PromotionTileFragment
      ...BannerPromotionTileFragment
      ...LinkedAccountsTileFragment
      ...CreditScoreTileFragment
      ...NextBestActionTileFragment
      ...VaroToAnyoneTileFragment
      ...ProductOfferTileFragment
      ...PayOverTimeItemsTileFragment
      ...VXLSideBySideTileFragment
      ...TopPerksTileFragment
      ...PartnerOfferTileFragment
      ...VXLTrackerCardTileFragment
      ...ColumnTaxTileFragment
      ...ProductOfferSingleCardTileFragment
      ...SelfFundedOfferTileFragment
      ...CheckListItemTileFragment
    }
  }
`;

//NOTE: this is used in tandem with fetchHomeTilesV2 so keeping it here
export const DeleteSystemBannerMutation = gql`
  mutation DismissBannerMessage($input: DismissBannerMessageInput!) {
    dismissBannerMessage(input: $input) {
      __typename
      ... on DismissBannerMessageSuccess {
        success
      }
      ... on DismissBannerMessageError {
        code
        title
        message
      }
    }
  }
`;

// NOTE: this query should be kept in perfect sync with FetchHomeTilesForIds
export const FetchHomeTilesV2 = gql`
  ${IllustrationStyleDictionaryFragment}
  ${TagFragment}
  ${AnalyticsEventFragment}
  ${AccountActionTileListFragment}
  ${RouteNavigationActionFragment}
  ${PromotionTileFragment}
  ${BannerPromotionTileFragment}
  ${QuickActionListFragment}
  ${InternalAccountTileFragment}
  ${LinkedAccountsTileFragment}
  ${CreditScoreTileFragment}
  ${NextBestActionTileFragment}
  ${PayOverTimeItemsTileFragment}
  ${VaroToAnyoneTileFragment}
  ${ProductOfferTileFragment}
  ${VXLSideBySideTileFragment}
  ${TopPerksTileFragment}
  ${PartnerOfferTileFragment}
  ${VXLTrackerCardTileFragment}
  ${VXLCardGroupTileFragment}
  ${DiscoverMoreProductRowTileFragment}
  ${VXLCardGroupDiscoverMoreTileFragment}
  ${SystemBannerFragment}
  ${ColumnTaxTileFragment}
  ${ProductOfferSingleCardTileFragment}
  ${SelfFundedOfferTileFragment}
  ${CheckListItemTileFragment}
  ${SDVerticalStackContainerTileFragment}

  query FetchHomeTilesV2($tileTypes: [TileType!]!) {
    homeTilesV2(input: { tileType: $tileTypes }) {
      __typename
      id
      tileType
      status
      navigationButton {
        label
        onPress {
          ...RouteNavigationActionFragment
        }
      }
      tiles {
        __typename
        id
        status
        tileType
        ...QuickActionListFragment
        ...InternalAccountTileFragment
        ...LinkedAccountsTileFragment
        ...PromotionTileFragment
        ...BannerPromotionTileFragment
        ...CreditScoreTileFragment
        ...NextBestActionTileFragment
        ...VaroToAnyoneTileFragment
        ...ProductOfferTileFragment
        ...PayOverTimeItemsTileFragment
        ...VXLSideBySideTileFragment
        ...TopPerksTileFragment
        ...PartnerOfferTileFragment
        ...VXLTrackerCardTileFragment
        ...VXLCardGroupTileFragment
        ...VXLCardGroupDiscoverMoreTileFragment
        ...ProductOfferSingleCardTileFragment
        ...SelfFundedOfferTileFragment
        ...SDVerticalStackContainerTileFragment
      }
      systemBanners {
        ...SystemBannerFragment
      }
    }
  }
`;

export const RefetchSystemBanners = gql`
  ${SystemBannerFragment}
  ${AnalyticsEventFragment}

  query FetchHomeTilesV2($tileTypes: [TileType!]!) {
    homeTilesV2(input: { tileType: $tileTypes }) {
      id
      tileType
      status
      systemBanners {
        ...SystemBannerFragment
      }
    }
  }
`;

// NOTE: this should be kept in perfect sync with FetchHomeTilesV2
export const FetchHomeTilesForIds = gql`
  ${IllustrationStyleDictionaryFragment}
  ${TagFragment}
  ${AnalyticsEventFragment}
  ${RouteNavigationActionFragment}
  ${AccountActionTileListFragment}
  ${NextBestActionTileFragment}
  ${PromotionTileFragment}
  ${BannerPromotionTileFragment}
  ${QuickActionListFragment}
  ${InternalAccountTileFragment}
  ${LinkedAccountsTileFragment}
  ${CreditScoreTileFragment}
  ${VaroToAnyoneTileFragment}
  ${PayOverTimeItemsTileFragment}
  ${ProductOfferTileFragment}
  ${VXLSideBySideTileFragment}
  ${TopPerksTileFragment}
  ${PartnerOfferTileFragment}
  ${VXLTrackerCardTileFragment}
  ${VXLCardGroupTileFragment}
  ${DiscoverMoreProductRowTileFragment}
  ${VXLCardGroupDiscoverMoreTileFragment}
  ${ProductOfferSingleCardTileFragment}
  ${ColumnTaxTileFragment}
  ${SelfFundedOfferTileFragment}
  ${CheckListItemTileFragment}
  ${SDVerticalStackContainerTileFragment}

  query FetchHomeTileForIds($ids: [ID!]!, $tileTypes: [TileType!]!) {
    tiles(id: $ids, input: { tileType: $tileTypes }) {
      id
      tileType
      status
      ...QuickActionListFragment
      ...InternalAccountTileFragment
      ...LinkedAccountsTileFragment
      ...PromotionTileFragment
      ...BannerPromotionTileFragment
      ...CreditScoreTileFragment
      ...NextBestActionTileFragment
      ...VaroToAnyoneTileFragment
      ...PayOverTimeItemsTileFragment
      ...ProductOfferTileFragment
      ...VXLSideBySideTileFragment
      ...TopPerksTileFragment
      ...PartnerOfferTileFragment
      ...VXLTrackerCardTileFragment
      ...VXLCardGroupTileFragment
      ...VXLCardGroupDiscoverMoreTileFragment
      ...ProductOfferSingleCardTileFragment
      ...ColumnTaxTileFragment
      ...SelfFundedOfferTileFragment
      ...CheckListItemTileFragment
      ...SDVerticalStackContainerTileFragment
    }
  }
`;
